KROWN.themeName = 'Split';
KROWN.themeVersion = '4.0.4';

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
      	e.target.classList.contains('button') ||
      	e.target.classList.contains('product-item') ||
      	e.target.classList.contains('spr-summary-actions-newreview') ||
      	e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  // if ( document.getElementById('site-filter-handle') ) {
  //   document.getElementById('site-filter-handle').addEventListener('click', e=>{
  //     e.preventDefault();
  //     document.getElementById('site-filters').show();
  //     document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
  //   });
  // }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-popup') ) {
    const newsletterPopup = document.getElementById('modal-popup');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));	
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }
      // ------------------- custom update check start----------

      console.log('Check cart update');
        $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart)
       {
            var checkboxkkk = cart.items.map(item => item.id.toString());
            var checkCount = cart.item_count ;
            //var itemid = cart.variant_id ;
            //alert(itemid);
            //alert('checkCount=> ' + checkCount );
           // console.log('checkCount=> ' + checkCount );
            console.log("checkboxkkk:", checkboxkkk);
           // var countxt = $('.custcart_count').text();
         setTimeout(function() {
             var cartCount = parseInt($('.count-holder').find('.count').text());
           console.log('Product count => ' + cartCount-1);
            if (checkboxkkk.includes("45113983762672")) {
                  $('.cust_check_box input').prop('checked', true);
                  $('.custcart_count').text(cartCount - 1)
                  $('span.count').text(cartCount - 1)
                  console.log("Checked successful");
            } else {
                console.log("Not checked");
                 $('.cust_check_box input').prop('checked', false);
            }
         
            var rmoveitem = '45113983762672';
            if (checkCount  === 1 || checkboxkkk == rmoveitem ) {
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                  quantity: 0,
                  id: rmoveitem
                },
                dataType: 'json',
                success: function(data) {
                  console.log("Removed from cart");
                  $.getJSON("/cart.js", function(cart) {
                  refreshCart(cart);
                  });
                },
                error: function(error) {
                  console.log('Error removing from cart');
                }
              });
            }
           // Console.log('checkCount=> ' + item_count);
           }, 1500);
        },
        error: function(error) {
            console.error("Error fetching cart:", error);
        }
    });

      // end --------------------
    });
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{
      eval(document.querySelector('#main-product-recommendations .js-fix-height').textContent);
    });
  }

}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

function scrollInto(elementId) {

  const offsetUp = -70;
  const offsetDown = -280;
    // Get the element by its ID
    const element = document.getElementById(elementId);
    
    if (!element) {
        console.log("Element not found!");
        return;
    }

    // Get the current position of the element relative to the viewport
    const elementPosition = element.getBoundingClientRect().top;

    // Determine whether we are scrolling up or down
    let offset = 0;

    if (elementPosition < 0) {
        // Scrolling down
        offset = offsetDown;
    } else {
        // Scrolling up
        offset = offsetUp;
    }

    // Perform the scroll to the element with the appropriate offset
    window.scrollBy({
        top: elementPosition + offset,
        behavior: 'smooth' // This ensures smooth scrolling
    });
}
//  function scrollInto(id) {
//   var elmnt = document.getElementById(id);
//   var elmntPosition = elmnt.getBoundingClientRect().top;
//   var currentScroll = window.scrollY;
  

//   if (elmntPosition + currentScroll < currentScroll) {
//     console.log("Scrolling Up to Element");
    
//  let downoffset = document.querySelector('.sticky_bar_addtocart').offsetHeight;
//     let headerHeight = document.querySelector('#site-header').offsetHeight;
//     let topOffset = 300 + "px"
//     console.log("topOffset", topOffset)
//     document.documentElement.style.scrollPaddingTop = topOffset;
//   } else {

//     console.log("Scrolling Down to Element");

//     let downoffset = document.querySelector('.sticky_bar_addtocart').offsetHeight + "px";
//     console.log("downoffset", downoffset)
//     document.documentElement.style.scrollPaddingTop = 300 + "px";
    
   
//   }
// setTimeout(()=>{
//   // Scroll into view
//   elmnt.scrollIntoView({
//     behavior: "smooth",
//     block: "start",
//     inline: "nearest"
//   });
//   console.log("function executed")
//   },200)
// }